/** @jsxImportSource @emotion/react */
import { SectionShort } from '@stories/atoms/Section/Section';
import RatingCard from '@stories/molecules/RatingCard';

import Carousel from '../Carousel';

import type { TRatingCard } from '@stories/molecules/RatingCard';
interface IRatingCarousel {
  headline?: string | null;
  cardData: TRatingCard[];
  fontSize?: string;
}
const RatingCarousel: React.FC<IRatingCarousel> = ({ headline, cardData, fontSize }) => {
  return (
    <SectionShort
      headline={headline}
      cssProps={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Carousel seamless slideGapCompensation={8}>
        {cardData.map((card) => (
          <RatingCard {...card} key={card.id} fontSize={fontSize}></RatingCard>
        ))}
      </Carousel>
      {/* <Button
        label="Bewertungen in trusted shop lesen"
        cssProps={{ marginTop: '2rem', display: 'none', [media('desktop')]: { display: 'flex' } }}
      ></Button>
      <Button
        label="Alle bewertungen lesen"
        cssProps={{ marginTop: '2rem', display: 'flex', [media('desktop')]: { display: 'none' } }}
      ></Button> */}
    </SectionShort>
  );
};

export default RatingCarousel;
